import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import AccountComponent from '../components/account/AccountComponent';

const Account = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <h1>{t('account.title')}</h1>
      <AccountComponent />
    </Fragment>
  );
};

export default Account;
